import React from 'react';

// One glyph per way a customer can reach the seller. The Contact button's settings modal
// shows them twice — small and grey in the method list, white on a dark square once a
// method is open — so they inherit `currentColor` and take their box size from the caller.
//
// Re-exported from ./index.js, which is the one import path the app uses for icons.

// Request form — a stack of input rows.
export const IconMethodFormSVG = ({ size = '16px' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2' y='2' width='12' height='12' rx='2.5' stroke='currentColor' strokeWidth='1.4' />
    <path d='M4.8 6h6.4M4.8 8.8h6.4M4.8 11.4h3.4' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' />
  </svg>
);

// Live chat — a speech bubble with a tail.
export const IconMethodChatSVG = ({ size = '16px' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.5 7.6c0 2.7-2.46 4.9-5.5 4.9-.63 0-1.24-.1-1.8-.27L3.3 13.5l.72-2.2A4.66 4.66 0 012.5 7.6c0-2.7 2.46-4.9 5.5-4.9s5.5 2.2 5.5 4.9z'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinejoin='round'
    />
    <path d='M5.9 7.6h4.2' stroke='currentColor' strokeWidth='1.3' strokeLinecap='round' />
  </svg>
);

// Messenger — a paper plane, the hand-off to an external app.
export const IconMethodMessengerSVG = ({ size = '16px' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.8 2.6L2.4 6.7l4 1.8m7.4-5.9L9.6 13.6l-1.9-4.3m6.1-6.7L7.7 9.3' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

// Email letter — an envelope.
export const IconMethodEmailSVG = ({ size = '16px' }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2' y='3.6' width='12' height='8.8' rx='2' stroke='currentColor' strokeWidth='1.4' />
    <path d='M2.9 5.2l5.1 3.6 5.1-3.6' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
